import { DataShapeName as e, FieldType as t } from "@vue-skuilder/common";
//#region \0rolldown/runtime.js
var n = Object.create, r = Object.defineProperty, __name = (e, t) => r(e, "name", {
	value: t,
	configurable: !0
}), i = Object.getOwnPropertyDescriptor, a = Object.getOwnPropertyNames, o = Object.getPrototypeOf, s = Object.prototype.hasOwnProperty, __commonJSMin = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), __copyProps = (e, t, n, o) => {
	if (t && typeof t == "object" || typeof t == "function") for (var c = a(t), l = 0, u = c.length, d; l < u; l++) d = c[l], !s.call(e, d) && d !== n && r(e, d, {
		get: ((e) => t[e]).bind(null, d),
		enumerable: !(o = i(t, d)) || o.enumerable
	});
	return e;
}, __toESM = (e, t, i) => (i = e == null ? {} : n(o(e)), __copyProps(t || !e || !e.__esModule ? r(i, "default", {
	value: e,
	enumerable: !0
}) : i, e)), c = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (e, t) => (typeof require < "u" ? require : e)[t] }) : e)(function(e) {
	if (typeof require < "u") return require.apply(this, arguments);
	throw Error("Calling `require` for \"" + e + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
}), l = [{
	name: e.Blanks,
	fields: [{
		name: "Input",
		type: t.MARKDOWN
	}, {
		name: "Uploads",
		type: t.MEDIA_UPLOADS
	}]
}];
//#endregion
export { __toESM as a, c as i, __commonJSMin as n, __name as r, l as t };

//# sourceMappingURL=shapes-BQUVJdp5.js.map